'use client'

import { ContentWrapper } from '@/General/ContentWrapper'
import { MasterclassButton } from '@/MasterclassButton'
import { useSubscriptionEligibility } from '@/useSubscriptionEligibility'
import { useStorefrontDisplayCurrency } from '@/useStorefrontDisplayCurrency'

export const TrialCTASection = () => {
  const {
    isSubscriber,
    hasHadSubscriptionBefore,
    isEligibleForTrial,
    isLoading,
  } = useSubscriptionEligibility()
  const { currencySymbol } = useStorefrontDisplayCurrency()

  // Don't show section if subscriber
  if (isSubscriber || isLoading) {
    return null
  }

  return (
    <section className="bg-[#f2f2f2] py-6 md:py-8">
      <ContentWrapper>
        <div className="max-w-2xl mx-auto text-center space-y-4">
          <h2 className="text-3xl font-bold">
            {hasHadSubscriptionBefore && !isEligibleForTrial
              ? 'Subscribe to Vanishing Inc. Masterclass'
              : 'Start your free trial of Vanishing Inc. Masterclass'}
          </h2>
          <MasterclassButton className="w-full py-3 bg-vi-red text-white rounded-md font-semibold hover:bg-vi-red-dark transition-colors" />
          <p className="text-vi-gray pt-2">
            {hasHadSubscriptionBefore && !isEligibleForTrial
              ? `Monthly subscription is ${currencySymbol}50.00 and automatically renews each month until cancelled.`
              : `After your trial, the monthly subscription is ${currencySymbol}50.00 and automatically renews each month until cancelled.`}
          </p>
        </div>
      </ContentWrapper>
    </section>
  )
}
